export const REQUESTED_ANSWER_REVIEW_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  FOLLOW_UP_REQUESTED: "FOLLOW_UP_REQUESTED",
} as const;

export type RequestedAnswerReviewStatus =
  (typeof REQUESTED_ANSWER_REVIEW_STATUS)[keyof typeof REQUESTED_ANSWER_REVIEW_STATUS];

export type RequestedAnswerReviewDecision = Exclude<
  RequestedAnswerReviewStatus,
  typeof REQUESTED_ANSWER_REVIEW_STATUS.PENDING
>;
